import useLang from "@/hooks/useLang";
import PopupPaper from "@/UI/components/PopupPaper";
import { useEffect } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import DashboardLayout from "./UI/components/DashboardLayout";
import BranchCategoryScreen from "./UI/screens/BranchCategoryScreen";
import BranchesScreen from "./UI/screens/BranchesScreen";
import BranchMenuScreen from "./UI/screens/BranchMenuScreen";
import ChooseLangScreen from "./UI/screens/ChooseLangScreen";
import ClientsScreen from "./UI/screens/ClientsScreen";
import CompleteDataScreen from "./UI/screens/CompleteDataScreen";
import CreateStoreScreen from "./UI/screens/CreateStoreScreen";
import HomeScreen from "./UI/screens/HomeScreen";
import LoginScreen from "./UI/screens/LoginScreen";
import MenuEditorScreen from "./UI/screens/MenuEditorScreen";
import MenuScreen from "./UI/screens/MenuScreen";
import PreviewMenuScreen from "./UI/screens/PreviewMenuScreen";
import CategoryProductsScreen from "./UI/screens/CategoryProductsScreen";
import NotFoundScreen from "./UI/screens/NotFoundScreen";
import ProfileScreen from "./UI/screens/ProfileScreen";
import SelectStoreScreen from "./UI/screens/SelectStoreScreen";
import SettingsScreen from "./UI/screens/SettingsScreen";
import OrdersScreen from "./UI/screens/OrdersScreen";
import SubscriptionBranchesScreen from "./UI/screens/SubscriptionBranchesScreen";
import SubscriptionsScreen from "./UI/screens/SubscriptionsScreen";
import SupportScreen from "./UI/screens/SupportScreen";
import VerifyOtpScreen from "./UI/screens/VerifyOtpScreen";

function RootLayout() {
    return (
        <>
            <Outlet />
            <PopupPaper />
        </>
    );
}

const router = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
            { path: "/choose-lang", element: <ChooseLangScreen /> },
            { path: "/login", element: <LoginScreen /> },
            { path: "/verify-otp", element: <VerifyOtpScreen /> },
            { path: "/complete-data", element: <CompleteDataScreen /> },
            { path: "/select-store", element: <SelectStoreScreen /> },
            { path: "/create-store", element: <CreateStoreScreen /> },
            /** Opens in its own tab, so it stays outside the dashboard layout — but still auth-gated. */
            { path: "/preview-menu", element: <PreviewMenuScreen /> },
            {
                path: "/",
                element: <DashboardLayout />,
                children: [
                    { index: true, element: <HomeScreen /> },
                    { path: "menu", element: <MenuScreen /> },
                    /** Unlinked from the UI on purpose — handed to freelance menu editors as a URL. */
                    { path: "menu-editor", element: <MenuEditorScreen /> },
                    { path: "menu/categories/:id", element: <CategoryProductsScreen /> },
                    { path: "branches", element: <BranchesScreen /> },
                    { path: "branches/:id", element: <BranchMenuScreen /> },
                    { path: "branches/:id/categories/:categoryId", element: <BranchCategoryScreen /> },
                    { path: "orders", element: <OrdersScreen /> },
                    { path: "clients", element: <ClientsScreen /> },
                    { path: "subscriptions", element: <SubscriptionsScreen /> },
                    { path: "subscriptions/branches", element: <SubscriptionBranchesScreen /> },
                    { path: "settings", element: <SettingsScreen /> },
                    { path: "support", element: <SupportScreen /> },
                    { path: "profile", element: <ProfileScreen /> },
                ],
            },
            { path: "*", element: <NotFoundScreen /> },
        ],
    },
]);

export default function Router() {
    const lang = useLang((state) => state.lang);

    useEffect(() => {
        document.documentElement.dir = lang === "en" ? "ltr" : "rtl";
        document.documentElement.lang = lang ?? "ar";
    }, [lang]);

    useEffect(() => {
        if (!lang && router.state.location.pathname !== "/choose-lang") router.navigate("/choose-lang");
    }, [lang]);

    return <RouterProvider router={router} />;
}
